import { type Shadows } from "@mui/material/styles";

import { shadows } from "design-tokens";

/** MUI's ladder is a 25-tuple whose first entry is the literal `'none'`. */
const LADDER_LENGTH = 25;

const SHALLOW_RUNGS = 8;

/**
 * A **floor, not a vocabulary** — nobody writes `elevation={n}`. MUI's own components pick
 * rungs for themselves (`Paper` 1, `Popover` 8, `Dialog` 24), and without this they would paint
 * Material's three-layer shadows instead of ours: alpha `.2/.14/.12` against our `.1`, noticeably
 * heavier and a different hue of black.
 *
 * **Rung 1 is `xs`, rungs 2-8 are `sm`.** `xs` is the button's depth, and a button has to name a rung
 * to reach it — so `MuiButton` and `ui/icon-button` read `theme.shadows[1]` at rest and
 * `theme.shadows[2]` on focus, rather than inheriting whatever MUI's `2 → 4 → 6 → 8` state walk lands on.
 * The only other default consumer of rung 1 is a bare `Paper`, which nothing in `src/ui` renders.
 *
 * **`lg` is deliberately absent.** Rung 8 is where `Popover` defaults, but it is also inside the `sm`
 * run, so every floating surface names `lg` itself — `MuiAutocomplete`, `ui/actions-menu`.
 *
 * Rung 0 stays `'none'`: its type is the string literal, so no token can live there.
 */
export const muiShadows = [
  "none",
  shadows.xs,
  ...Array<string>(SHALLOW_RUNGS - 1).fill(shadows.sm),
  ...Array<string>(LADDER_LENGTH - SHALLOW_RUNGS - 1).fill(shadows.md),
] as Shadows;
